import {useMutation} from "react-query"
import { useMainContext } from "../../contexts/main"
import { postApiWithToken } from "../fetch-api/post"
import {useQueryContext} from "../../contexts/query";
import {useProfileQuery} from "./useProfileQuery";
import {useAuthContext} from "../../contexts/auth";


/**
 * p2p deep trade - Post api
 * @param onClose {Function}
 * @returns {UseMutation}
 */
const useDeepTradeMutation = (onClose) => {

    const { profile: { token }, setLoading } = useMainContext()
    const {queryClient, setToast} = useQueryContext()
    const { refetchProfile } = useAuthContext()

    return useMutation(
        'deep-trade', (data) => postApiWithToken(data, token, "trades/deep"),
        {
            onSuccess: (res) => {
                onClose()
                setToast({
                    message: "trade-success-desc", isError: false, show: true
                })
                setLoading(true)
                setTimeout(() => {
                    queryClient.invalidateQueries('fetch-my-orders')
                    queryClient.invalidateQueries('fetch-orders-history')
                    refetchProfile()
                    setLoading(false)
                }, 2000)
            },
            onError: (res) => {
                setLoading(false)
                onClose()
            }
        }
    )
}

/**
 * Wage calculator - Post api
 * @returns {UseMutation}
 */
const useWageCalculator = () => {
    const { profile: { token } } = useMainContext()

    return useMutation(
        'wages-calculator', (data) => postApiWithToken(data, token, "settings/wages/calculate"),
    )
}




export {
    useDeepTradeMutation,
    useWageCalculator
}

